import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/scheduling/')({
  component: SchedulesIndex,
});

function SchedulesIndex() {
  return <>scheduling dashboard will be here</>;
}
